import { Injectable, TemplateRef } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ToastService {
  toasts: any[] = [];

  delay = 5000;

  show(textOrTpl: string | TemplateRef<any>, options: any = {}) {
    this.toasts.push({ textOrTpl, ...options });
  }

  remove(toast: any) {
    this.toasts = this.toasts.filter(t => t !== toast);
  }

  showInfo(message: string) {
    console.info(message);
    this.show(message, { classname: 'bg-primary text-center text-white', delay: this.delay });
  }

  showSuccess(message: string) {
    console.info(message);
    this.show(message, { classname: 'bg-success text-center text-white', delay: this.delay });
  }

  showDanger(message: string) {
    console.error(message);
    this.show(message, { classname: 'bg-danger text-center text-white', delay: this.delay });
  }

  showWarning(message: string) {
    console.warn(message);
    this.show(message, { classname: 'bg-warning text-center text-white', delay: this.delay });
  }
}
